/*
 * gift-landing.js — поведение подарочной посадочной.
 *
 * Три независимых маленьких модуля:
 *  1) сезонный герой подборки [data-gift-hero] — переключатель формата
 *     «подарочная / дегустационная» и добавление всех позиций формата в
 *     корзину одним запросом (контракт tea-sets.js: свойство `_Сет`,
 *     секции cart-notification/cart-drawer);
 *  2) герой-оффер [data-gift-flagship-add] — ajax-добавление флагмана с
 *     единственным вариантом (товары с выбором варианта сюда не попадают —
 *     у них CTA является ссылкой на PDP);
 *  3) сертификат [data-gift-cert] — чипы номиналов синхронизируют ссылку и
 *     подпись CTA.
 *
 * Суммы героя (чай, упаковка, дополнительно, всего, цены в подписях
 * форматов) скрипт складывает из агорот конфига [data-gift-hero-items] и
 * форматирует по shop.money_format (паттерн ds-cart-notification): тумблер
 * «сделать подарком» и замены сортов делают комбинации динамическими,
 * пререндер сервера — только стартовое состояние. Успешное добавление
 * открывает cart notification без текста-статуса; текст остался у ошибок.
 * Инициализация идемпотентна (data-*-ready), Theme Editor
 * переинициализируется на shopify:section:load.
 */

(function () {
  if (window.giftLanding) return;
  window.giftLanding = true;

  /* ---- деньги: как ds-cart-notification.formatMoney, ".00" отрезается ---- */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    if (amount.slice(-3) === '.00') amount = noDecimals;
    return (format || '{{ amount }} ₪')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ---- общая отправка позиций в корзину (контракт tea-sets.js) ----
     onSuccess (опционально) заменяет стандартный рендер корзины —
     кнопка «Оформить» после добавления сразу уводит в checkout. */
  function addItems(items, statusEl, btn, messages, onSuccess) {
    var routes = window.routes || {};
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender()
        .map(function (s) { return s.section || s.id; })
        .filter(Boolean);
      body.sections_url = window.location.pathname;
    }

    if (statusEl) {
      statusEl.textContent = '';
      statusEl.removeAttribute('data-state');
    }
    btn.classList.add('loading');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (response) {
          if (!r.ok || (response.status && response.status >= 400)) {
            throw new Error(response.description || response.message || 'Cart add failed');
          }
          return response;
        });
      })
      .then(function (response) {
        if (onSuccess) {
          onSuccess(response);
        } else if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (statusEl && messages.success) {
            statusEl.textContent = messages.success;
            statusEl.setAttribute('data-state', 'success');
          }
        } else {
          window.location = routes.cart_url || '/cart';
        }
      })
      .catch(function () {
        if (statusEl && messages.error) {
          statusEl.textContent = messages.error;
          statusEl.setAttribute('data-state', 'error');
        }
      })
      .then(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  }

  /* ---- 1. сезонный герой подборки ---- */
  function initHolidayHero(root) {
    if (root.hasAttribute('data-gift-hero-ready')) return;
    root.setAttribute('data-gift-hero-ready', '');

    var dataEl = root.querySelector('[data-gift-hero-items]');
    if (!dataEl) return;
    var config;
    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var current = root.getAttribute('data-gift-hero-format') || 'gift';
    var selected = {}; /* variantId выбранного аксессуара -> цена в агорот */
    var giftOn = config.giftOn === true; /* тумблер «сделать подарком» */
    var subIndex = {}; /* слот состава -> индекс кандидата замены (0 — исходный) */
    var buttons = root.querySelectorAll('[data-gift-hero-format-btn]');
    var teapotBtns = root.querySelectorAll('[data-gift-teapot]');
    var addBtn = root.querySelector('[data-gift-hero-add]');
    var checkoutBtn = root.querySelector('[data-gift-hero-checkout]');
    var statusEl = root.querySelector('[data-gift-hero-status]');
    var priceEl = root.querySelector('[data-gift-price]');
    var detailEl = root.querySelector('[data-gift-bill-detail]');
    var teaEl = root.querySelector('[data-gift-bill-tea]');
    var extrasRow = root.querySelector('[data-gift-bill-extras-row]');
    var extrasEl = root.querySelector('[data-gift-bill-extras]');
    var wrapRow = root.querySelector('[data-gift-bill-wrap-row]');
    var wrapEl = root.querySelector('[data-gift-bill-wrap]');
    var teaCards = root.querySelectorAll('[data-gift-tea-slot]');
    var swapBtns = root.querySelectorAll('[data-gift-tea-swap]');
    var formatPriceEls = root.querySelectorAll('[data-gift-format-price]');
    var giftDetailEl = root.querySelector('[data-gift-format-detail="gift"]');
    var chipCountEl = root.querySelector('[data-gift-chip-count]');
    var chipWeightEl = root.querySelector('[data-gift-chip-weight]');
    var wrapToggle = root.querySelector('[data-gift-wrap-toggle]');
    var wrapPriceEl = root.querySelector('[data-gift-wrap-price]');
    var wrapNoteRow = root.querySelector('[data-gift-wrap-row]');
    var ctaEl = root.querySelector('[data-gift-cta]');
    var setTitle = root.getAttribute('data-set-title');
    var setHandle = root.getAttribute('data-set-handle') || '';
    var messages = {
      success: root.getAttribute('data-add-success') || '',
      error: root.getAttribute('data-add-error') || ''
    };

    /* сумма чая формата: подарочный — по слотам с учётом замен,
       дегустационный — из пререндеренной суммы пробников */
    function packTeaSum(format) {
      var pack = config[format] || {};
      if (pack.slots) {
        var sum = 0;
        pack.slots.forEach(function (subs, i) {
          if (!subs.length) return;
          var cand = subs[(subIndex[i] || 0) % subs.length];
          if (cand && cand.available !== false) sum += cand.price;
        });
        return sum;
      }
      return pack.teaTotal || 0;
    }

    /* коробка формата: только при включённом тумблере */
    function packWrapPrice(format) {
      var pack = config[format] || {};
      return giftOn && pack.wrapId ? pack.wrapPrice || 0 : 0;
    }

    /* состав подарочного формата с учётом замен: количество, одинаковость
       фасовок, общий вес — замены могут быть другой граммовки, поэтому
       чипы, подпись формата и строка чека пересчитываются */
    function giftComposition() {
      var slots = (config.gift && config.gift.slots ? config.gift.slots : []);
      var comp = { count: slots.length, total: 0, first: 0, same: true };
      slots.forEach(function (subs, i) {
        if (!subs.length) return;
        var cand = subs[(subIndex[i] || 0) % subs.length];
        var w = cand && cand.weight ? cand.weight : 0;
        if (!comp.first) comp.first = w;
        else if (w !== comp.first) comp.same = false;
        comp.total += w;
      });
      return comp;
    }

    /* «6 × 50 g» (или просто «6» при разных фасовках) */
    function compCountLabel(comp) {
      var unit = config.unit || 'g';
      var s = String(comp.count);
      if (comp.same && comp.first > 0) s += ' × ' + comp.first + ' ' + unit;
      return s;
    }

    /* «6 × 50 g · 300 g» — строка чека */
    function compDetailLabel(comp) {
      var unit = config.unit || 'g';
      var s = compCountLabel(comp);
      if (comp.total > 0) s += ' · ' + comp.total + ' ' + unit;
      return s;
    }

    /* ---- галерея героя: точки под фото + autoplay, паттерн DS-галереи PDP
       (product-system.js): пользовательское действие останавливает
       автопрокрутку насовсем; переключение формата прыгает на слайд коробки
       формата (data-gift-slide-role) и тоже останавливает автопрокрутку. */
    var gallery = root.querySelector('[data-gift-gallery]');
    var slides = gallery
      ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gift-slide]'))
      : [];
    var galleryDotsWrap = gallery ? gallery.querySelector('[data-gift-dots]') : null;
    var galleryDots = [];
    var galleryIdx = 0;
    var galleryTimer = null;
    var galleryStopped = false;
    var galleryInterval = gallery
      ? parseInt(gallery.getAttribute('data-ds-autoplay'), 10) || 5000
      : 5000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function galleryGo(index) {
      if (!slides[index]) return;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      galleryDots.forEach(function (d, i) {
        if (i === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      galleryIdx = index;
    }

    function galleryStop() {
      if (galleryTimer) clearInterval(galleryTimer);
      galleryTimer = null;
    }

    function galleryUserStop() {
      galleryStopped = true;
      galleryStop();
    }

    function galleryStart() {
      if (galleryStopped || reduceMotion || slides.length < 2 || galleryTimer) return;
      galleryTimer = setInterval(function () {
        galleryGo((galleryIdx + 1) % slides.length);
      }, galleryInterval);
    }

    /* слайд по роли: 'gift'/'taster' — коробка формата,
       '<формат>-nobox' — пакеты без коробки; -1 — слайда нет */
    function gallerySlideByRole(role) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-gift-slide-role') === role) return i;
      }
      return -1;
    }

    /* слайд текущего формата с учётом тумблера упаковки:
       включена — коробка, выключена — фото без коробки */
    function galleryStateSlide() {
      return giftOn ? gallerySlideByRole(current) : gallerySlideByRole(current + '-nobox');
    }

    if (slides.length > 1 && galleryDotsWrap) {
      slides.forEach(function (s, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        dot.addEventListener('click', function () {
          galleryUserStop();
          galleryGo(i);
        });
        galleryDotsWrap.appendChild(dot);
        galleryDots.push(dot);
      });
      galleryGo(0);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) galleryStop();
        else galleryStart();
      });
      galleryStart();
    }

    /* Полный пересчёт из агорот конфига: чай (с заменами), коробка (по
       тумблеру), дополнительно, всего, цены в подписях форматов. */
    function render() {
      var pack = config[current] || {};
      var extras = 0;
      var picked = 0;
      Object.keys(selected).forEach(function (id) {
        extras += selected[id];
        picked += 1;
      });

      var teaSum = packTeaSum(current);
      var wrap = packWrapPrice(current);

      /* состав с учётом замен: строка чека (для подарочного формата),
         чипы после заголовка и подпись формата «Стандарт» */
      var comp = config.gift && config.gift.slots ? giftComposition() : null;
      if (detailEl) {
        if (current === 'gift' && comp) detailEl.textContent = compDetailLabel(comp);
        else if (pack.detail) detailEl.textContent = pack.detail;
      }
      if (comp) {
        if (chipCountEl) chipCountEl.textContent = compCountLabel(comp);
        if (chipWeightEl) chipWeightEl.textContent = comp.total + ' ' + (config.unit || 'g');
        if (giftDetailEl) giftDetailEl.textContent = compCountLabel(comp);
      }
      if (teaEl) teaEl.textContent = formatMoney(teaSum, config.money);
      /* строка упаковки: скрыта при выключенном тумблере и у формата
         без коробки */
      if (wrapEl) {
        wrapEl.textContent = wrap ? formatMoney(wrap, config.money) : '';
        if (wrapRow) wrapRow.hidden = !wrap;
      }
      /* карточки состава: видимая кнопка — текущий формат и выбранная
         замена слота; у каждой кнопки свой quick view (см. секцию) */
      var takenIds = {};
      if (config.gift && config.gift.slots) {
        config.gift.slots.forEach(function (slotSubs, j) {
          if (!slotSubs || !slotSubs.length) return;
          var cur = slotSubs[(subIndex[j] || 0) % slotSubs.length];
          if (cur) takenIds[cur.id] = true;
        });
      }
      teaCards.forEach(function (card) {
        var slot = Number(card.getAttribute('data-gift-tea-slot'));
        var subs = (config.gift && config.gift.slots ? config.gift.slots : [])[slot] || [];
        var idx = subs.length ? (subIndex[slot] || 0) % subs.length : 0;
        card.querySelectorAll('[data-gift-tea-open]').forEach(function (b) {
          var fmt = b.getAttribute('data-gift-tea-open');
          var sub = b.getAttribute('data-gift-sub');
          b.hidden = fmt !== current || (sub != null && Number(sub) !== idx);
        });
        /* «заменить» — только в подарочном формате: у пробников замен нет.
           Гаснет (disabled), когда менять не на что: все кандидаты слота
           уже выбраны в других слотах — дубль сорта ломает счёт группы. */
        var swapBtn = card.querySelector('[data-gift-tea-swap]');
        if (swapBtn) {
          swapBtn.hidden = current !== 'gift';
          var canSwap = false;
          for (var s = 0; s < subs.length; s += 1) {
            if (s === idx) continue;
            if (!takenIds[subs[s].id]) {
              canSwap = true;
              break;
            }
          }
          swapBtn.disabled = !canSwap;
        }
      });
      if (extrasRow) extrasRow.hidden = picked === 0;
      if (extrasEl) extrasEl.textContent = picked ? formatMoney(extras, config.money) : '';

      var totalLabel = formatMoney(teaSum + wrap + extras, config.money);
      if (priceEl) priceEl.textContent = totalLabel;
      if (ctaEl) {
        ctaEl.textContent = config.cta ? config.cta + ' · ' + totalLabel : totalLabel;
      }

      /* цены в подписях форматов следуют тумблеру и заменам */
      formatPriceEls.forEach(function (el) {
        var fmt = el.getAttribute('data-gift-format-price');
        el.textContent = formatMoney(packTeaSum(fmt) + packWrapPrice(fmt), config.money);
      });

      /* факт-строка упаковки: aria и красная иконка по положению тумблера,
         цена — коробка текущего формата */
      if (wrapToggle) wrapToggle.setAttribute('aria-checked', giftOn ? 'true' : 'false');
      if (wrapPriceEl) {
        wrapPriceEl.textContent = pack.wrapId
          ? '(+' + formatMoney(pack.wrapPrice || 0, config.money) + ')'
          : '';
      }
      if (wrapNoteRow) {
        if (giftOn) wrapNoteRow.removeAttribute('data-wrap-off');
        else wrapNoteRow.setAttribute('data-wrap-off', '');
      }

      buttons.forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-gift-hero-format-btn') === current ? 'true' : 'false');
      });
      teapotBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', selected[b.getAttribute('data-variant-id')] != null ? 'true' : 'false');
      });
      root.setAttribute('data-gift-hero-format', current);

      /* сумма конфигурации — наружу: секция «До бесплатной доставки»
         на той же странице пересчитывает бар (initDeliverySync) */
      root.dispatchEvent(new CustomEvent('gift-hero:total', {
        bubbles: true,
        detail: { total: teaSum + wrap + extras }
      }));
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-gift-hero-format-btn');
        render();
        /* упаковка включена — слайд коробки формата; выключена — фото
           формата без коробки (если задано в настройках) */
        var stateSlide = galleryStateSlide();
        if (stateSlide > -1) {
          galleryUserStop();
          galleryGo(stateSlide);
        }
      });
    });

    if (wrapToggle) {
      wrapToggle.addEventListener('click', function () {
        giftOn = !giftOn;
        render();
        /* включили — коробка формата на главном фото; выключили — фото
           формата без коробки, а без него назад к фото подборки */
        var stateSlide = galleryStateSlide();
        if (stateSlide > -1) {
          galleryUserStop();
          galleryGo(stateSlide);
        } else if (!giftOn && slides.length) {
          galleryUserStop();
          galleryGo(0);
        }
      });
    }

    swapBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slot = Number(btn.getAttribute('data-slot'));
        var slots = config.gift && config.gift.slots ? config.gift.slots : [];
        var subs = slots[slot];
        if (!subs || subs.length < 2) return;
        /* Кандидат не должен дублировать чай, уже выбранный в другом слоте:
           одинаковые строки Shopify мёржит в одну с qty 2 — состав в корзине
           и счётчик группы едут. Занятые id пропускаем; если все кандидаты
           заняты — остаёмся на текущем. */
        var taken = {};
        slots.forEach(function (other, j) {
          if (j === slot || !other || !other.length) return;
          var cur = other[(subIndex[j] || 0) % other.length];
          if (cur) taken[cur.id] = true;
        });
        var start = (subIndex[slot] || 0) % subs.length;
        var next = start;
        for (var step = 1; step <= subs.length; step += 1) {
          var idx = (start + step) % subs.length;
          if (!taken[subs[idx].id]) {
            next = idx;
            break;
          }
        }
        if (next === start) return;
        subIndex[slot] = next;
        render();
      });
    });

    teapotBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-variant-id');
        /* повторный клик по выбранной карточке снимает выбор */
        if (selected[id] != null) {
          delete selected[id];
        } else {
          selected[id] = Number(b.getAttribute('data-variant-price')) || 0;
        }
        render();
      });
    });

    function collectItems() {
      var pack = config[current] || {};
      var ids = [];
      if (pack.slots) {
        pack.slots.forEach(function (subs, i) {
          if (!subs.length) return;
          var cand = subs[(subIndex[i] || 0) % subs.length];
          if (cand && cand.available !== false) ids.push(cand.id);
        });
      } else if (pack.items) {
        ids = pack.items.slice();
      }
      if (!ids.length) return null;
      if (giftOn && pack.wrapId) ids.push(pack.wrapId);
      // Отпечаток состава: одинаковые конфигурации мёржатся Shopify в одну
      // группу (счётчик ×N в корзине), любое отличие даёт отдельную группу.
      // Подборка = чаи + коробка; аксессуары в отпечаток и группу не входят —
      // они едут в корзину обычными отдельными строками (без `_Сет*`).
      var setKey = setHandle + '|' + ids.map(Number).sort(function (a, b) { return a - b; }).join('-');
      var items = ids.map(function (id) {
        var item = { id: Number(id), quantity: 1 };
        if (setTitle) item.properties = { '_Сет': setTitle, '_СетКлюч': setKey };
        return item;
      });
      Object.keys(selected).forEach(function (id) {
        items.push({ id: Number(id), quantity: 1 });
      });
      return items;
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.classList.contains('loading')) return;
        var items = collectItems();
        if (items) addItems(items, statusEl, addBtn, messages);
      });
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (checkoutBtn.classList.contains('loading')) return;
        var items = collectItems();
        if (!items) return;
        addItems(items, statusEl, checkoutBtn, messages, function () {
          var routes = window.routes || {};
          window.location = (routes.cart_url || '/cart') + '/checkout';
        });
      });
    }

    render();
  }

  /* ---- 2. флагман с единственным вариантом ---- */
  function initFlagship(btn) {
    if (btn.hasAttribute('data-gift-flagship-ready')) return;
    btn.setAttribute('data-gift-flagship-ready', '');

    btn.addEventListener('click', function () {
      if (btn.classList.contains('loading')) return;
      var id = Number(btn.getAttribute('data-variant-id'));
      if (!id) return;
      var scope = btn.closest('[data-gift-flagship]') || document;
      var statusEl = scope.querySelector('[data-gift-flagship-status]');
      addItems([{ id: id, quantity: 1 }], statusEl, btn, {
        success: btn.getAttribute('data-add-success') || '',
        error: btn.getAttribute('data-add-error') || ''
      });
    });
  }

  /* ---- 3.5 случайный порядок карточек ----
     Ячейки с data-gift-shuffle (полка sets_auto, аксессуары-фолбэк героя)
     перемешиваются Фишером—Йетсом в пределах своего родителя: сервер
     тасовать не может (кэш секций). Смежные ячейки вставляются на место
     последней. data-gift-shuffle-max="N" на родителе прячет карточки
     дальше N-й — случайная выборка из коллекции побольше. */
  function initShuffleGroups() {
    var cells = Array.prototype.slice.call(document.querySelectorAll('[data-gift-shuffle]'));
    var parents = [];
    cells.forEach(function (cell) {
      var parent = cell.parentElement;
      if (parent && parents.indexOf(parent) === -1) parents.push(parent);
    });
    parents.forEach(function (parent) {
      if (parent.hasAttribute('data-gift-shuffle-ready')) return;
      parent.setAttribute('data-gift-shuffle-ready', '');
      var group = cells.filter(function (cell) { return cell.parentElement === parent; });
      if (group.length > 1) {
        var anchor = group[group.length - 1].nextSibling;
        for (var i = group.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = group[i];
          group[i] = group[j];
          group[j] = tmp;
        }
        group.forEach(function (cell) {
          parent.insertBefore(cell, anchor);
        });
      }
      var max = parseInt(parent.getAttribute('data-gift-shuffle-max'), 10);
      if (max > 0) {
        group.forEach(function (cell, index) {
          cell.hidden = index >= max;
        });
      }
    });
  }

  /* ---- 3.7 живой прогресс «До бесплатной доставки» ----
     Секция ds-delivery-progress рендерится сервером от cart.total_price;
     на детальной подборки сумма меняется тумблером/заменами/аксессуарами —
     герой шлёт gift-hero:total, и бар пересчитывается как в
     cart-free-shipping-progress: корзина + текущая конфигурация блока.
     Пороги, money-формат и локализованные строки — в data-атрибутах секции. */
  function initDeliverySync(rootEl) {
    if (rootEl.hasAttribute('data-delivery-sync-ready')) return;
    rootEl.setAttribute('data-delivery-sync-ready', '');
    var progress = rootEl.querySelector('cart-shipping-progress');
    if (!progress) return;

    var base = Number(rootEl.getAttribute('data-base-total')) || 0;
    var pickup = Number(rootEl.getAttribute('data-pickup')) || 0;
    var courier = Number(rootEl.getAttribute('data-courier')) || 0;
    if (!pickup || !courier) return;
    var money = rootEl.getAttribute('data-money') || '';
    var freeLabel = rootEl.getAttribute('data-free-label') || '';
    var fromLabel = rootEl.getAttribute('data-from-label') || '';
    var msgs = {
      remaining: rootEl.getAttribute('data-msg-remaining') || '',
      pickup: rootEl.getAttribute('data-msg-pickup-unlocked') || '',
      courier: rootEl.getAttribute('data-msg-courier-unlocked') || ''
    };
    var cartSumEl = rootEl.querySelector('.delivery-progress__cart strong');
    var msgEl = progress.querySelector('.cart-shipping-progress__message');
    var dots = {
      pickup: progress.querySelector('.cart-shipping-progress__dot--pickup'),
      courier: progress.querySelector('.cart-shipping-progress__dot--courier')
    };
    var stones = {
      pickup: progress.querySelector('.cart-shipping-progress__milestone--pickup'),
      courier: progress.querySelector('.cart-shipping-progress__milestone--courier')
    };
    var DOT_CHECK = '<svg class="cart-shipping-progress__dot-check" viewBox="0 0 20 20" width="11" height="11" fill="none" aria-hidden="true"><path d="M4.5 10.2L8.1 13.7L15.5 6.3" stroke="#ffffff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var MSG_CHECK = '<svg class="cart-shipping-progress__message-check" viewBox="0 0 20 20" width="15" height="15" fill="none" aria-hidden="true"><path d="M4.5 10.2L8.1 13.7L15.5 6.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function setState(el, state) {
      if (!el) return;
      el.classList.remove('is-reached', 'is-target', 'is-future');
      el.classList.add('is-' + state);
    }

    function update(total) {
      var pct = Math.min(100, Math.round((total * 100) / courier));
      progress.style.setProperty('--cart-progress', pct + '%');

      var state = total >= courier ? 'courier_unlocked' : total >= pickup ? 'before_courier' : 'before_pickup';
      progress.className = progress.className.replace(/cart-shipping-progress--\S+/, 'cart-shipping-progress--' + state);

      var pickupState = state === 'before_pickup' ? 'target' : 'reached';
      var courierState = state === 'courier_unlocked' ? 'reached' : 'future';
      setState(dots.pickup, pickupState);
      setState(dots.courier, courierState);
      if (dots.pickup) dots.pickup.innerHTML = pickupState === 'reached' ? DOT_CHECK : '';
      if (dots.courier) dots.courier.innerHTML = courierState === 'reached' ? DOT_CHECK : '';

      setState(stones.pickup, pickupState);
      setState(stones.courier, courierState);
      var pickupSmall = stones.pickup && stones.pickup.querySelector('small');
      if (pickupSmall) {
        pickupSmall.textContent = pickupState === 'reached'
          ? freeLabel
          : fromLabel + ' ' + Math.round(pickup / 100) + ' ₪';
      }
      var courierSmall = stones.courier && stones.courier.querySelector('small');
      if (courierSmall) {
        courierSmall.textContent = courierState === 'reached'
          ? freeLabel
          : fromLabel + ' ' + Math.round(courier / 100) + ' ₪';
      }

      if (msgEl) {
        if (state === 'before_pickup') {
          msgEl.classList.remove('cart-shipping-progress__message--success');
          var amount = '<span class="cart-shipping-progress__amount">' + formatMoney(pickup - total, money) + '</span>';
          msgEl.innerHTML = msgs.remaining.replace('@@AMOUNT@@', amount);
        } else {
          msgEl.classList.add('cart-shipping-progress__message--success');
          msgEl.innerHTML = MSG_CHECK + (state === 'courier_unlocked' ? msgs.courier : msgs.pickup);
        }
      }

      if (cartSumEl) cartSumEl.textContent = formatMoney(total, money);
    }

    document.addEventListener('gift-hero:total', function (e) {
      var heroTotal = e.detail && e.detail.total ? e.detail.total : 0;
      update(base + heroTotal);
    });
  }

  /* ---- 3. чипы номиналов сертификата ---- */
  function initCert(root) {
    if (root.hasAttribute('data-gift-cert-ready')) return;
    root.setAttribute('data-gift-cert-ready', '');

    var chips = root.querySelectorAll('[data-gift-cert-value]');
    var cta = root.querySelector('[data-gift-cert-cta]');
    var ctaLabel = root.querySelector('[data-gift-cert-cta-label]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
        });
        if (cta) cta.setAttribute('href', chip.getAttribute('data-url'));
        if (ctaLabel) ctaLabel.textContent = chip.getAttribute('data-price-label');
      });
    });
  }

  function init() {
    /* прогресс доставки подписывается ДО героя: стартовый render() героя
       уже шлёт gift-hero:total, и бар сразу учитывает подборку */
    document.querySelectorAll('[data-delivery-sync]').forEach(initDeliverySync);
    document.querySelectorAll('[data-gift-hero]').forEach(initHolidayHero);
    document.querySelectorAll('[data-gift-flagship-add]').forEach(initFlagship);
    initShuffleGroups();
    document.querySelectorAll('[data-gift-cert]').forEach(initCert);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
